// Warm Western Decor Theme
export const theme = {
  colors: {
    // Burn Orange for Buttons
    primary: '#CC5500',        // Burn Orange
    primaryDark: '#B84400',    // Darker Burn Orange
    primaryLight: '#FF6B1A',   // Light Burn Orange
    
    secondary: '#FF7F3F',      // Lighter Orange
    secondaryDark: '#B84400',  // Dark Burn Orange
    secondaryLight: '#FFA366', // Light Orange
    
    accent: '#1a1a1a',         // Matte Black for borders and accents
    accentLight: '#2a2a2a',    // Light Matte Black
    
    background: '#f5f5f5',     // Matte White/Light Gray
    surface: '#ffffff',        // Pure White
    surfaceAlt: '#e8e8e8',     // Light Matte Gray
    
    // Text colors - Matte Black and White
    text: '#1a1a1a',           // Matte Black
    textSecondary: '#2a2a2a',  // Dark Gray
    textLight: '#4a4a4a',      // Medium Gray
    textOnDark: '#ffffff',     // White text for dark backgrounds
    textOnDarkSecondary: '#f5f5f5', // Off-white for dark backgrounds
    
    border: '#d0d0d0',         // Light Gray
    borderLight: '#e8e8e8',    // Very Light Gray
    
    // Call-to-action colors (Cart & CTA buttons) - Burn Orange
    cta: '#CC5500',            // Burn Orange
    ctaDark: '#B84400',        // Darker Burn Orange
    ctaHover: '#E8661A',       // Brighter Burn Orange on hover
    
    success: '#22c55e',        // Green
    warning: '#f59e0b',        // Amber
    error: '#ef4444',          // Red
    info: '#3b82f6',           // Blue
    
    // Overlay colors
    overlay: 'rgba(0, 0, 0, 0.5)',
    overlayLight: 'rgba(0, 0, 0, 0.3)',
  },
  
  spacing: {
    xs: '0.25rem',    // 4px
    sm: '0.5rem',     // 8px
    md: '1rem',       // 16px
    lg: '1.5rem',     // 24px
    xl: '2rem',       // 32px
    xxl: '3rem',      // 48px
  },
  
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    '2xl': '24px',
    full: '9999px',
    round: '50%',
  },
  
  shadows: {
    sm: '0 1px 3px rgba(92, 62, 40, 0.12)',
    md: '0 4px 6px rgba(92, 62, 40, 0.15)',
    lg: '0 10px 20px rgba(92, 62, 40, 0.2)',
    xl: '0 20px 40px rgba(92, 62, 40, 0.25)',
  },
  
  typography: {
    fontFamily: {
      primary: "'Playfair Display', 'Merriweather', Georgia, serif", // Headings
      secondary: "'Lato', 'Open Sans', Arial, sans-serif", // Body text
    },
    fontSize: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      base: '1rem',     // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      '2xl': '1.5rem',  // 24px
      '3xl': '1.875rem', // 30px
      '4xl': '2.25rem',  // 36px
      '5xl': '3rem',     // 48px
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  transitions: {
    fast: '150ms ease-in-out',
    base: '250ms ease-in-out',
    slow: '350ms ease-in-out',
  },
  
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
  },
};

export default theme;

